// store/slices/uiSlice.js - UI state slice

// API base URL for datasheet proxy - must be explicit for iframe src
// In development, React's proxy doesn't work for iframe src attributes
const API_BASE_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000';

export const createUISlice = (set) => ({
  // Node Selection
  selectedNodeId: null,
  setSelectedNodeId: (nodeId) => set({ selectedNodeId: nodeId }),

  // Panel State
  isPanelCollapsed: { left: false, right: false },
  togglePanel: (panel) => set((state) => ({
    isPanelCollapsed: {
      ...state.isPanelCollapsed,
      [panel]: !state.isPanelCollapsed[panel]
    }
  })),

  // Note Modal
  isNoteModalOpen: false,
  editingNoteId: null,
  openNoteModal: (nodeId) => set({
    isNoteModalOpen: true,
    editingNoteId: nodeId
  }),
  closeNoteModal: () => set({
    isNoteModalOpen: false,
    editingNoteId: null
  }),

  // Datasheet Modal
  isDatasheetModalOpen: false,
  currentDatasheetUrl: null,
  currentDatasheetPartNumber: null,
  openDatasheetModal: (partNumber) => {
    // PDF viewer parameters:
    // - pagemode=thumbs: show thumbnail sidebar
    // - view=FitH: fit to page width
    // - toolbar=0: hide toolbar (not widely supported)
    // Note: Browser PDF viewers don't support hiding specific toolbar buttons
    const url = `${API_BASE_URL}/api/datasheet/${partNumber}#pagemode=thumbs&view=FitH`;
    set({
      isDatasheetModalOpen: true,
      currentDatasheetUrl: url,
      currentDatasheetPartNumber: partNumber
    });
  },
  closeDatasheetModal: () => set({
    isDatasheetModalOpen: false,
    currentDatasheetUrl: null,
    currentDatasheetPartNumber: null
  }),

  // Component Details Panel
  isComponentDetailsPanelOpen: false,
  isComponentDetailsPanelPinned: false,
  openComponentDetailsPanel: () => set({ isComponentDetailsPanelOpen: true }),
  closeComponentDetailsPanel: () => set((state) => ({
    isComponentDetailsPanelOpen: false,
    isComponentDetailsPanelPinned: false
  })),
  toggleComponentDetailsPanel: () => set((state) => ({
    isComponentDetailsPanelOpen: !state.isComponentDetailsPanelOpen
  })),
  toggleComponentDetailsPanelPin: () => set((state) => ({
    isComponentDetailsPanelPinned: !state.isComponentDetailsPanelPinned
  })),

  // Floating Inspector
  isInspectorOpen: false,
  isInspectorPinned: false,
  inspectorPosition: null,
  openInspector: () => set((state) => {
    const defaultPosition = {
      x: window.innerWidth - 370,
      y: 80
    };
    return {
      isInspectorOpen: true,
      inspectorPosition: state.inspectorPosition || defaultPosition
    };
  }),
  closeInspector: () => set({ isInspectorOpen: false }),
  toggleInspector: () => set((state) => ({ isInspectorOpen: !state.isInspectorOpen })),
  toggleInspectorPin: () => set((state) => ({ isInspectorPinned: !state.isInspectorPinned })),
  setInspectorPosition: (position) => set({ inspectorPosition: position }),

  // Chain Mode
  chainMode: localStorage.getItem('chainMode') !== 'false',
  toggleChainMode: () => set((state) => {
    const newChainMode = !state.chainMode;
    localStorage.setItem('chainMode', newChainMode.toString());
    return { chainMode: newChainMode };
  }),

  // Canvas Load Transition - Feature flag and state
  // Set ENABLE_CANVAS_LOAD_TRANSITION to false to revert to original behavior
  ENABLE_CANVAS_LOAD_TRANSITION: true,
  isCanvasLoading: false,
  setCanvasLoading: (loading) => set({ isCanvasLoading: loading }),
});
